import { memo } from 'react'

import { Loader } from '~/shared/ui/Loader'

import { LOADING_STATE_MIN_HEIGHT } from './config'
import type { LoadingStateProps } from './types'

import styles from './LoadingState.module.scss'

/**
 * Ожидание данных: спиннер по центру зоны нужной высоты.
 *
 * Временно заменяет скелетоны (основатель, п.11: «скелетоны выглядят сломанными, сделай пока
 * спиннер по центру»). Правило 14 CLAUDE.md про скелетоны по форме контента остаётся в силе —
 * вернёмся к ним, когда формы будут выверены; тогда достаточно поменять этот компонент.
 */
export const LoadingState = memo(function LoadingState(props: LoadingStateProps) {
  const { size = 'M' } = props

  return (
    <div className={styles.root} style={{ minHeight: LOADING_STATE_MIN_HEIGHT[size] }}>
      <Loader size={size === 'S' ? 'S' : 'M'} />
    </div>
  )
})
